import React from 'react';
import myPhoto1 from '../images/photo1.png';
import Projects from './Projects';
import Experiences from './Experiences';

//
import Csharp from '../images/CSharp.svg';
import Kotlin from '../images/kotlin.svg';
import JS from '../images/JS.svg';
import Java from '../images/Java.svg';
import Delphi from '../images/Delphi.png';
import react from '../images/React.png';
import ReactNative from '../images/ReactNative.svg';
import Azure from '../images/Azure.svg';
import DotNetCore from '../images/DotNetCore.svg';
import MSSQL from '../images/MSSQL.svg';
import MySQL from '../images/MySQL.svg';

import Interests from './Interests';

const Main = () => {
  const projectsData = [
    {
      projectName: 'Starbucks Shelf Life Tracker App',
      briefInfo:
      'This app helps Starbucks partners efficiently track product shelf life dates. It features quick product lookup via RESTful APIs and custom widgets for iOS and Android, providing instant access to expiration dates without opening the app. Powered by Azure App Service and SQL Server for scalability. Additionally, it offers key points on recent events based on user-registered keywords and location, and allows users to engage with a community by sharing keywords and stories.',
      gitLink: 'https://github.com/Gemnnn/sbux-support-app',
    },
    {
      projectName: 'Initiate News',
      briefInfo:
      'Initiate News condenses daily news into brief summaries, based on the keyword the user registered and location, providing key points on recent events. Plus, it will be able to engage with a community of like-minded individuals by sharing keywords and stories.',
      gitLink: 'https://github.com/Gemnnn/Initiate-News',
    },
    {
      projectName: 'Virtual Game Store',
      briefInfo:
      'The multiplatform app is a one-stop shop for gamers, offering game and merchandise purchases, event enrollments, and review writing. Users can add friends and family. It includes an admin panel for managing orders, CRUD for games, merchandise, events, approving reviews, and generating sales reports.',
      gitLink: 'https://github.com/junseo-yang/virtual-game-store',
    },
    {
      projectName: 'Mini Games',
      briefInfo:
      'This is a mini-game application that allows you to enjoy various simple games. I created it because I love games and want to study Kotlin in-depth.',
      gitLink: 'https://github.com/Gemnnn/Android_Projects/tree/main/Project/MiniGames',
    },
    {
      projectName: 'My stagram',
      briefInfo:
        'To study Android Studio and Kotlin a little more in-depth, I am developing a social media application based on the concept of Instagram.',
      gitLink: 'https://github.com/Gemnnn/Android_Projects/tree/main/Project/Mystagram',
    },
    {
      projectName: 'BellGeekfest 2023 (TCM)',
      briefInfo:
        'Participated in a three-day hackathon hosted by Bell that focused on developing technology solutions for online privacy and security. My team developed a privacy-preserving Chrome extension that leverages the OpenAI API and uses React and Vite on the front-end, with a Flask backend implemented in Python.',
      gitLink: 'https://github.com/junseo-yang/BellGeekfest2023',
    },
    {
      projectName: 'BellGeetfest 2022',
      briefInfo: 
        'I participated in a three-day hackathon hosted by Bell that focused on diversity. Our team developed a diversity translator and diversity calendar using React.',
      gitLink: '#',
    }
    // Add more projects as needed
  ];
  const experiencesData = [
    {
      companyName: 'LG CNS America', 
      position: 'Manufacturing System Engineer', 
      date: 'Feb 2026 - Recent', 
      location: "Windsor, ON", 
      job: 
        '• Design structured AI-assisted prompt workflows and Oracle SQL diagnostic queries to break down complex Smart Factory logic, validate production data, and identify root causes of system failures, process delays, and command conflicts.' + 
        '• Optimize and manage automated logistics systems for Canada’s first EV battery Gigafactory, covering Electrode, Assembly, and Formation processes. \n ' + 
        '• Lead deep-dive analysis of Real-Time Dispatching (RTD) rule logic to troubleshoot material flow issues, carrier selection failures, dispatch delays, and command conflicts across automated logistics operations. \n ' +
        '• Analyze and design logistics operation scenarios by translating complex customer requirements into automated system workflows. \n ' +
        '• Synchronize and validate critical data interfaces between MES, MCS/CIM, and RTD to ensure high-fidelity data integrity across the manufacturing hierarchy.'
    },
    {
      companyName: 'Manse eSolution Inc.', 
      position: 'Data Analysis & Junior Developer', 
      date: 'Aug 2022 - Aug 2023', 
      location: "Guelph - Hybrid", 
      job: 
        '• Supported the development of a grain elevator management system used by 80+ clients across Ontario to track grain movement, from truck intake to storage and release. \n ' + 
        '• Converted a non-interactive Google Maps view into an intuitive Delphi-based tool which enabled users to select 2+ clients on the map; allowed drag-and-drop functionality with immediate batch updates. \n ' + 
        '• Wrote and optimized complex MySQL queries for real-time accuracy in ticketing systems, enhancing customer experience by promptly addressing data correction requests. \n ' +
        '• Managed and cleaned large-scale client data, resolving inconsistencies in high-volume grain inventory tables leading to a 30% reduction in query resolution time and smoother database operations. \n ' +
        '• Improved the system\'s UI/UX to reflect a more intuitive and professional interface, drawing from design sensitivity honed during prior creative experience.'
    },
    {
      companyName: 'Starbucks', 
      position: 'Shift Supervisor', 
      date: 'Jun 2021 - Nov 2024', 
      location: "Toronto & Waterloo", 
      job: 
        '• Created the best Starbucks experience by connecting with customers and contributing to store and company operations through best-in-class customer service. \n ' + 
        '• Grew Customer Connection score from 29 to 48 \n ' +
        '• Managing daily operations, ensuring smooth workflow and adherence to Starbucks standards. \n ' +
        '• Provided hands-on technical support, including software installations and troubleshooting on client systems, ensuring smooth and reliable operations.' 
    }
  ];

  const imageData = [
    {
      image: Csharp,
      name: "C Sharp"
    },
    {
      image: DotNetCore,
      name: ".Net Core"
    },
    {
      image: Kotlin,
      name: "Kotlin"
    },
        {
      image: JS,
      name: "JavaScript"
    },
    {
      image: react,
      name: "React"
    },
        {
      image: ReactNative,
      name: "React Native"
    },
    {
      image: Delphi,
      name: "Delphi"
    },
    {
      image: Java,
      name: "Java"
    },
    {
      image: Azure,
      name: "Azure"
    },
    {
      image: MSSQL,
      name: "MSSQL"
    },
    {
      image: MySQL,
      name: "MySQL"
    },
  ];

  const AnimatedText = ({ text }) => {
    const letters = text.split('').map((letter, index) => (
      <span key={index} className="animated-fadein" style={{ animationDelay: `${index * 0.07}s` }}>
        {letter}
      </span>
    ));
  
    return <h1>{letters}</h1>;
  };
  

  // const sendEmail = (sectionId) => {
  //   const section = document.getElementById(sectionId);
  // }

  return (
    <div className='body'>
      <div className='main'>
        {/* <div className='container'>
          <div className='headline'>
            <h1>Junior Developer</h1>
            <h1>& Coffee Enthusiast.</h1>
          </div>
        </div> */}
        {/*  */}
        <div className='container'>
          <div className='headline'>
            {/* <h1 className='animated-text'>Junior Developer</h1>
            <h1 className='animated-text'>& Coffee Enthusiast.</h1> */}
              <AnimatedText text="System  Engineer" />
              <AnimatedText text="& Coffee  Enthusiast " />
          </div>
        </div>
        {/*  */}
        <div className='mainbody'>
          <div className="body1">
            <img src={myPhoto1} alt="Branden Min presenting at a professional event" />
          </div>
          <div className="body2" id='body2'>
            <h3>"Committed Developer with a Vision for Leadership and Continuous Growth"</h3>
            <p>&nbsp;</p>
            <p>
              I work at the intersection of smart factory systems, automated logistics, data analysis, and AI-assisted engineering. 
              <br /><br />My current focus is Real-Time Dispatching (RTD) and MES-driven material flow for large-scale EV battery manufacturing. <br /><br />I analyze complex business logics, troubleshoot carrier and material transfer issues, validate master data, and build applications and Oracle SQL-based diagnostic queries that help identify where automated logistics decisions fail.
            </p>
          </div>
        </div>
        <div className='experiences' id='experiences'>
            <h2>Experiences</h2>
            <div className="experience-container">
                {experiencesData.map((project, index) => (
                    <Experiences key={index} {...project} />
                ))}
            </div>
        </div>
        <div id='projects' className='projects'>
            <h2>Projects</h2>
            <div className="project-container mx-auto grid max-w-6xl grid-cols-1 gap-6 px-4 md:grid-cols-2 lg:grid-cols-3">
                {projectsData.map((project, index) => (
                    <Projects key={index} {...project} />
                ))}
            </div>
        </div>
        <div className='interests' id='interests'>
            <h2>Interests</h2>
            <div className='image-container'>
              {imageData.map((project, index) => (
               <Interests key={index} {...project} /> 
              ))}
            </div>
        </div>
        <div className='contact' id='contact'>
            {/* <h2>Contact</h2> */}
            {/* <div className='message-input'>
              <input
                type='tel'
                placeholder='Recipient Phone Number'
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
              />
              <input
                type='text'
                placeholder='Send me a message...'
                value={userMessage}
                onChange={handleInputChange}
              />
              <button onClick={handleSendMessage}>Send SMS</button>
            </div> */}
            {/* <button onClick={sendEmail}>Send E-mail</button> */}
        </div>
      </div>
    </div>
  );
};

export default Main;
